export default function Vision() {
    return (
        <>
            <div class="Home_leftcorevalue__1zekh row">
                <div class="Home_lcorevaluecover__bcsd2 col">
                    <div class="Home_lcorelist__2wWAx">
                        <div
                            className="aboutVisionDesc">
                            <div
                                className="aboutVisionBorder">
                                <img
                                    style={{ maxWidth: "100%", display: "block", margin: "0", border: "none", padding: "0" }}
                                    alt="" aria-hidden="true" role="presentation"
                                    src="/images/visionimage.webp" />
                            </div>
                        </div>
                        <h3>Our Vision</h3>
                        <p>Owning a place we can call our own and living in peace and comfort in it, has always been one of the main aims of mankind. Our house is not just a building, it is our home; A place where we are happy and content. At buildAhome, we build you the house you've always dreamt off by providing services along with our work experience over years having an excellence in every step making sure that your home couldn’t be built better. For we do not believe in building homes alone, we believe in making dreams come true &amp; Making sure that Every Penny paid is worth it</p>
                    </div>
                </div>
                <div class="Home_lcorevaluecover__bcsd2 col">
                    <div class="Home_lcorelist__2wWAx">
                        <div className="aboutVisionDesc" >
                            <div
                                className="aboutVisionBorder">
                                <img style={{ maxWidth: "100%", display: "block", margin: "0", border: "none", padding: "0" }}
                                    alt="" aria-hidden="true" role="presentation"
                                    src="/images/visionFeatureimage.webp" />
                            </div>
                        </div>
                        <h3>Featuring</h3>
                        <ul>
                            <li>New &amp; Trending Designs</li>
                            <li>No Subcontracts</li>
                            <li>No Hidden Charges</li>
                            <li>Tech Enabled buildAhome Application</li>
                            <li>1 Year Construction Guarantee &amp; 10 Year Waterproofing Warranty</li>
                            <li>Timely Delivery</li>
                            <li>Fair pricing</li>
                            <li>High quality work with No Compromise </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}